interface IconFallbackProps {
  icon: string;
  className?: string;
  width?: string | number;
  height?: string | number;
  fallback?: string;
}

// Fallback SVG icons as strings
const fallbackIcons: Record<string, string> = {
  'mdi:loading': '⏳',
  'lucide:home': '🏠',
  'lucide:user': '👤',
  'lucide:heart': '❤️',
  'lucide:arrow-left': '←',
  'lucide:arrow-right': '→',
  'lucide:chevron-right': '›',
  'lucide:edit': '✏️',
  'lucide:save': '💾',
  'lucide:x': '✕',
  'lucide:menu': '☰',
  'lucide:sun': '☀️',
  'lucide:moon': '🌙',
  'lucide:camera': '📷',
  'lucide:upload': '⬆️',
  // Social Media Icons
  'simple-icons:x': '𝕏',
  'simple-icons:twitter': '🐦',
  'simple-icons:substack': '📝',
  'mdi:linkedin': '💼',
  'lucide:linkedin': '💼',
  'mdi:github': '🐙',
  'simple-icons:github': '🐙',
  'lucide:github': '🐙',
  'simple-icons:facebook': '📘',
  'lucide:facebook': '📘',
  'mdi:facebook': '📘',
  // Other Icons
  'lucide:external-link': '↗',
  'mdi:open-in-new': '↗',
  'lucide:eye': '👁️',
  'lucide:calendar': '📅',
  'lucide:clock': '🕐',
  'lucide:tag': '🏷️',
  'lucide:search': '🔍',
  'lucide:filter': '🔽',
  'lucide:plus': '➕',
  'lucide:trash': '🗑️',
  'lucide:settings': '⚙️',
  'noto:construction': '🚧',
  'lucide:edit-2': '✏️',
  'lucide:trash-2': '🗑️',
  'lucide:image-plus': '🖼️',
  'lucide:check-circle': '✅',
  'lucide:loader-2': '⏳',
  'lucide:circle': '○',
  'mdi:map-marker': '📍',
  'lucide:map-pin': '📍',
  'mdi:send': '📤',
  'lucide:send': '📤',
  'lucide:copy': '📋'
};

export function IconFallback({ 
  icon, 
  className = '', 
  width = '20', 
  height = '20',
  fallback 
}: IconFallbackProps) {
  // Use fallback immediately to avoid CSP issues
  const fallbackChar = fallback || fallbackIcons[icon] || '•';
  
  return (
    <span 
      className={`inline-block text-center ${className}`}
      style={{ 
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
        lineHeight: typeof height === 'number' ? `${height}px` : height,
        fontSize: typeof height === 'number' ? `${Math.max(12, height - 4)}px` : '14px'
      }}
      title={`Icon: ${icon}`}
    >
      {fallbackChar}
    </span>
  );
}
